<template>
    <div>
        <projetos 
            :projetos="projetos"
            v-show="mostrarProjetos"
            :servicos="obterServicos()"
            @atualizarFiltro="atualizarFiltro($event)"
        >
            <template slot="acoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('SGTEC-FORN-PRJ-01')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharProjeto(data.projetoId)"
                    ></i>
                </span>
            </template>
        </projetos>
        <router-view></router-view>
    </div>
</template>

<script>
import ProjetosServicos from './ProjetosServicos'
import Projetos from '@/app/sgtec/componentes/projetos/Projetos'

export default {
    data() {
        return {
            projetos: [],
            filtro: {
                dataInicial: this.$moment(new Date())
                .startOf('year')
                .format('DD/MM/YYYY'),
                dataFinal: this.$moment(new Date())
                    .endOf('year')
                    .format('DD/MM/YYYY'),
                tipoContratacao: 'TODAS',
                natureza: 'TODAS',
                modulo: "TODOS",
                codSolucao: 0,
            },
        }
    },
    methods: {
        obterServicos() {
            return ProjetosServicos
        },

        atualizarFiltro(filtro) {
            this.filtro = filtro
            this.obterProjetos()
        },

        obterProjetos() {
            this.$store.dispatch('addRequest')
            ProjetosServicos.obterTodos(this.filtro).then(response => {
                if (response) {
                    if (response.success) {
                        this.projetos = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharProjeto(projetoId) {
            this.$router.push({
                name: 'Sgtec_Fornecedor_Projetos_Detalhar',
                params: {
                    projetoId: projetoId
                }
            })
        }
    },

    created() {
    },

    computed: {
        mostrarProjetos() {
            return this.$route.name === 'Sgtec_Fornecedor_Projetos'
        }
    },

    components: {
        Projetos: Projetos
    },

    watch: {
        $route(to) {
            if (to.name === 'Sgtec_Fornecedor_Projetos') {
                if (this.$store.getters.recarregar) {
                    this.obterProjetos()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    }
}
</script>
